import api from "./api";
import { API_ENDPOINTS } from "../constants/API_ENDPOINTS";

interface WhatsAppUpdateResponse {
  success: boolean;
  message: string;
}

const whatsappService = {
  // Request a WhatsApp update link
  requestUpdate: async (): Promise<WhatsAppUpdateResponse> => {
    try {
      const response = await api.post<WhatsAppUpdateResponse>(
        API_ENDPOINTS.REQUEST_WHATSAPP_UPDATE
      );
      return response.data;
    } catch (error: any) {
      console.error("Error requesting WhatsApp update:", error);
      throw new Error(
        error.response?.data?.detail || "Failed to request WhatsApp update"
      );
    }
  },

  // Update WhatsApp number using token
  updateNumber: async (
    token: string,
    whatsappNumber: string
  ): Promise<WhatsAppUpdateResponse> => {
    try {
      const response = await api.post<WhatsAppUpdateResponse>(
        `${API_ENDPOINTS.UPDATE_WHATSAPP}/${token}`,
        { whatsapp_number: whatsappNumber }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error updating WhatsApp number:", error);
      throw new Error(
        error.response?.data?.detail || "Failed to update WhatsApp number"
      );
    }
  },

  // Verify WhatsApp update token
  verifyToken: async (token: string): Promise<WhatsAppUpdateResponse> => {
    try {
      const response = await api.get<WhatsAppUpdateResponse>(
        `${API_ENDPOINTS.VERIFY_WHATSAPP_TOKEN}/${token}`
      );
      return response.data;
    } catch (error: any) {
      console.error("Error verifying WhatsApp token:", error);
      throw new Error(
        error.response?.data?.detail || "Failed to verify WhatsApp token"
      );
    }
  },
};

export default whatsappService;
